export const PLACEHOLDERS = {
  DEFAULT_PICKUP_LOCATION: 'Pickup & Drop off',
  PICKUP_LOCATION: 'Pickup',
  DROPOFF_LOCATION: 'Drop off',
  PASSENGERS: 'Passengers',
  PASSENGERS_WITH_HOTEL: '1 Passenger, 1 Room',
  SEARCH_BUTTON: 'Search',
  ORIGIN: 'Departing from?',
  DESTINATION: 'Going to?'
} as const

export const LABELS = {
  ADD_HOTEL: 'Add Hotel',
  ADD_FLIGHT: 'Add Flight',
  DIFFERENT_DROPOFF: 'Drop-off at a different location',
  PACKAGE_DEALS: 'Package Deals',
  CAR_CATEGORY: 'Car type',
  PASSENGERS: 'Passengers',
  PASSENGERS_WITH_HOTEL: 'Passengers with Hotel',
  DEFAULT_PICKUP_LOCATION: 'Pickup & Drop off',
  PICKUP_LOCATION: 'Pickup',
  PICKUP_TIME: 'Pickup time',
  PICKUP_DATE: 'Pickup',
  DROPOFF_LOCATION: 'Drop off',
  DROPOFF_DATE: 'Drop off',
  DROPOFF_TIME: 'Drop off time'
} as const

export const DEFAULT_VALUES = {
  ADD_HOTEL: false,
  ADD_FLIGHT: false,
  DIFFERENT_DROPOFF: false,
  PICKUP_TIME: '12:00',
  DROPOFF_TIME: '12:00'
} as const
